import logo from "./logo.svg";
import "./App.css";
import { useLocation } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import * as Page from "./Page";
import ErrorPage from "./error-page";

import ParticleKupuKupu from "./Components/ParticleKupu_Kupu/ParticleKupuKupu";
import Navbar from "./Components/Navbar/Navbar";
const router = [
  {
    path: "/",
    element: <Page.Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi",
    element: <Page.NavigasiDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-bimantara",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-kampana",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-arsa",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-adhyasta",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-syandana",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-sambara",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-dayaka",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-sarwaga",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-prabangkara",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/divisi-wiskira",
    element: <Page.FotoDivisi />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/hari-pelaksanaan",
    element: <Page.HariPelaksanaan />,
    errorElement: <ErrorPage />,
  },
  {
    path: "hari-hari-omb",
    element: <Page.HariHariOMB />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/after-movie",
    element: <Page.AfterMovie />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/hari-pelaksanaan/:hariID",
    element: <Page.HariHariOMB />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/dibalik-kepanitiaan",
    element: <Page.DibalikPanit />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/sayembara-visual",
    element: <Page.SayembaraVisual />,
    errorElement: <ErrorPage />,
  },
  // {
  //   path: "/*",
  // },
];

function App() {
  let location = useLocation();

  console.log("location", location);

  return (
    <div className="App">
      <div className="route">
        <Navbar />
        <Routes>
          {router.map((e) => {
            return (
              <Route
                path={e.path}
                element={e.element}
                errorElement={e.errorElement}
              />
            );
          })}
        </Routes>
      </div>
      {location.pathname !== "/" && <ParticleKupuKupu />}
    </div>
  );
}

export default App;
